import { Func, Core } from '../vendor/lib';

class Parent {
  
}

Object.assign(Parent, Func);
Object.assign(Parent, Core);

export default Parent;


// WEBPACK FOOTER //
// ./src/model/Parent.js